// extracted by mini-css-extract-plugin
export default {"tenant":"tenant_tenant__uFegm","content":"tenant_content__-eg7v"};